import { optionTitle_adsv2 } from './AdvertisingOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { areAdsEnabled } from 'owa-mail-ads-checker';
import { isGdprAdMarket } from 'owa-mail-ads-shared';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let AdvertisingOption: LazyOption = createLazyOption(
    {
        key: 'advertise_options',
        titleStringKey: optionTitle_adsv2,
        searchTermsStringKey: optionTitle_adsv2,
        hideTitleInFullOptions: true,
        isHidden: () => !(isFeatureEnabled('fwk-gdprAdsV2') && isGdprAdMarket() && areAdsEnabled()),
    },
    lazyFullModule,
    m => m.default
);
export default AdvertisingOption;
